export default __webpack_public_path__ + "static/bohdan-3c9a0ab5116e2f5616faf756569bbed6.png";